import FlightSchedule from '@/components/flight-schedule/FlightSchedule'
import headerComponent from '@/modules/header'

function getFlightScheduleContainers () {
  return document
    .querySelectorAll('.flight-schedule')
    .filter(el => !el.dataset.initialized)
}

function initializeFlightSchedule (el) {
  const fs = new FlightSchedule({ el })
  fs.$el.dataset.initialized = 'true'
}

export function init () {
  headerComponent.logo(true)

  getFlightScheduleContainers().forEach(initializeFlightSchedule)
}



// WEBPACK FOOTER //
// ./src/modules/flightSchedule.js